import { Selectbox } from '@policygenius/mortar';
import { ReactText } from 'react';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { SelectFieldProps } from './types';
import styles from '../styles';
import useField from '../useField';

const useStyles = createUseStyles(styles);

const SelectField = <Value extends ReactText>({
  id,
  name,
  config,
  ...props
}: SelectFieldProps<Value>) => {
  const classes = useStyles();
  const { input, meta } = useField<Value, HTMLSelectElement, string>(name, config);

  return (
    <div className={classes.fieldContainer}>
      <Selectbox
        {...input}
        {...props}
        value={input.value ?? undefined}
        id={id ?? input.name}
        errorMessage={getErrorMessage(meta)}
        defaultValue={meta.initial ?? undefined}
      />
    </div>
  );
};

export default SelectField;
